import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import FiledViewItem from "./FiledViewItem";
import FiledSummaryDetails from "./FiledSummaryDetails";

export default function FiledPreviewDialog({ open, onClose, onConfirm, item, loading }) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Así quedará radicado el documento</DialogTitle>
      <DialogContent>
        {item && (
          <>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <FiledViewItem item={item} />
            </Box>
            <FiledSummaryDetails item={item} />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={onConfirm} variant="contained" autoFocus disabled={loading}>
          {loading ? <CircularProgress size={24} /> : <span>Confirmar y radicar</span>}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
